<template>
  <div class="error-network text-center">
    <div class="row">
      <div class="col-md-12">
        <terminal-icon size="150" class="mb-4"/>
        <h1>Ops... Um erro inesperado aconteceu!</h1>
        <hr>
      </div>
      <div class="col-md-12">
        <button @click="sendToHome()" type="button" class="btn btn-primary btn-xl" data-dismiss="modal">Clique aqui para voltar</button>
      </div>
    </div>
  </div>

</template>

<script>
  import { TerminalIcon } from 'vue-feather-icons'

  export default {
    components: { TerminalIcon },
    methods: {
      sendToHome() {
        localStorage.removeItem('startPath')
        this.$ls.clearAccountUser()

        this.$router.push('/')
        .then(() => console.log('reload'))
        .then(() => window.location.reload(true))
        .catch(e => this.$notify.addError(e))
      }
    },
    name: 'ErrorNetwork'
  }
</script>

<style scoped>

.error-network{
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
}

</style>
